export interface SieveRecord {
  id: string;
  sieveSizeMm: number;
  label: string;
}

interface SieveDefinitionRecord {
  id: string;
  sieveSizeMm: number;
  label: string;
  labelAstm?: string;
  maxAllowedMass: number;
  maxAllowedMassAstm?: number;
  minimumRecommendedMassAfterRiffling?: number;
}

export const knownSieves: SieveDefinitionRecord[] = [
  {
    id: "125",
    sieveSizeMm: 125,
    label: "125 mm",
    maxAllowedMass: 3951,
  },
  {
    id: "90",
    sieveSizeMm: 90,
    label: "90 mm",
    maxAllowedMass: 3353,
  },
  {
    id: "75",
    sieveSizeMm: 75,
    label: "75 mm",
    labelAstm: "3",
    maxAllowedMass: 3061,
    maxAllowedMassAstm: 2700,
  },
  {
    id: "63",
    sieveSizeMm: 63,
    label: "63 mm",
    maxAllowedMass: 2800,
  },
  {
    id: "50",
    sieveSizeMm: 50,
    label: "50 mm",
    labelAstm: "2",
    maxAllowedMass: 2499,
    maxAllowedMassAstm: 2000,
  },
  {
    id: "37.5",
    sieveSizeMm: 37.5,
    label: "37.5 mm",
    labelAstm: "1-½",
    maxAllowedMass: 2100,
    maxAllowedMassAstm: 1500,
  },
  {
    id: "31.5",
    sieveSizeMm: 31.5,
    label: "31.5 mm",
    maxAllowedMass: 1984,
  },
  {
    id: "28",
    sieveSizeMm: 28,
    label: "28 mm",
    maxAllowedMass: 1870,
  },
  {
    id: "25",
    sieveSizeMm: 25,
    label: "25 mm",
    labelAstm: "1",
    maxAllowedMass: 1767,
    maxAllowedMassAstm: 1100,
  },
  {
    id: "20",
    sieveSizeMm: 20,
    label: "20 mm",
    maxAllowedMass: 1500,
  },
  {
    id: "19",
    sieveSizeMm: 19,
    label: "19 mm",
    labelAstm: "¾",
    maxAllowedMass: 1541,
    maxAllowedMassAstm: 900,
  },
  {
    id: "16",
    sieveSizeMm: 16,
    label: "16 mm",
    maxAllowedMass: 1414,
  },
  {
    id: "14",
    sieveSizeMm: 14,
    label: "14 mm",
    maxAllowedMass: 1322,
  },
  {
    id: "12.5",
    sieveSizeMm: 12.5,
    label: "12.5 mm",
    labelAstm: "½",
    maxAllowedMass: 1273,
    maxAllowedMassAstm: 660,
  },
  {
    id: "11.2",
    sieveSizeMm: 11.2,
    label: "11.2 mm",
    maxAllowedMass: 1183,
  },
  {
    id: "10",
    sieveSizeMm: 10,
    label: "10 mm",
    maxAllowedMass: 1100,
    minimumRecommendedMassAfterRiffling: 500,
  },
  {
    id: "9.5",
    sieveSizeMm: 9.5,
    label: "9.5 mm",
    labelAstm: "⅜",
    maxAllowedMass: 1089,
    maxAllowedMassAstm: 550,
  },
  {
    id: "8",
    sieveSizeMm: 8,
    label: "8 mm",
    maxAllowedMass: 1000,
  },
  {
    id: "6.3",
    sieveSizeMm: 6.3,
    label: "6.3 mm",
    maxAllowedMass: 800,
    minimumRecommendedMassAfterRiffling: 300,
  },
  {
    id: "5.6",
    sieveSizeMm: 5.6,
    label: "5.6 mm",
    maxAllowedMass: 836,
  },
  {
    id: "5",
    sieveSizeMm: 5,
    label: "5 mm",
    maxAllowedMass: 790,
  },
  {
    id: "4.75",
    sieveSizeMm: 4.75,
    label: "4.75 mm",
    labelAstm: "No.4",
    maxAllowedMass: 770,
    maxAllowedMassAstm: 325,
  },
  {
    id: "4",
    sieveSizeMm: 4,
    label: "4 mm",
    maxAllowedMass: 707,
  },
  {
    id: "3.36",
    sieveSizeMm: 3.36,
    label: "3.36 mm",
    maxAllowedMass: 288,
  },
  {
    id: "3.35",
    sieveSizeMm: 3.35,
    label: "3.35 mm",
    labelAstm: "No.8",
    maxAllowedMass: 285,
    maxAllowedMassAstm: 198,
  },
  {
    id: "2.36",
    sieveSizeMm: 2.36,
    label: "2.36 mm",
    maxAllowedMass: 241,
  },
  {
    id: "2",
    sieveSizeMm: 2,
    label: "2 mm",
    labelAstm: "No.10",
    maxAllowedMass: 220,
    maxAllowedMassAstm: 180,
    minimumRecommendedMassAfterRiffling: 100,
  },
  {
    id: "1.4",
    sieveSizeMm: 1.4,
    label: "1.4 mm",
    maxAllowedMass: 186,
  },
  {
    id: "1.18",
    sieveSizeMm: 1.18,
    label: "1.18 mm",
    labelAstm: "No.16",
    maxAllowedMass: 171,
    maxAllowedMassAstm: 134,
  },
  {
    id: "1",
    sieveSizeMm: 1,
    label: "1 mm",
    maxAllowedMass: 157,
  },
  {
    id: "0.85",
    sieveSizeMm: 0.85,
    label: "0.85 mm",
    labelAstm: "No.20",
    maxAllowedMass: 144,
    maxAllowedMassAstm: 115,
  },
  {
    id: "0.71",
    sieveSizeMm: 0.71,
    label: "0.71 mm",
    maxAllowedMass: 132,
  },
  {
    id: "0.63",
    sieveSizeMm: 0.63,
    label: "0.63 mm",
    labelAstm: "No.30",
    maxAllowedMass: 125,
    maxAllowedMassAstm: 91,
    minimumRecommendedMassAfterRiffling: 100,
  },
  {
    id: "0.6",
    sieveSizeMm: 0.6,
    label: "0.6 mm",
    maxAllowedMass: 122,
  },
  {
    id: "0.5",
    sieveSizeMm: 0.5,
    label: "0.5 mm",
    maxAllowedMass: 111,
  },
  {
    id: "0.425",
    sieveSizeMm: 0.425,
    label: "0.425 mm",
    labelAstm: "No.40",
    maxAllowedMass: 102,
    maxAllowedMassAstm: 75,
  },
  {
    id: "0.355",
    sieveSizeMm: 0.355,
    label: "0.355 mm",
    maxAllowedMass: 94,
  },
  {
    id: "0.3",
    sieveSizeMm: 0.3,
    label: "0.3 mm",
    labelAstm: "No.50",
    maxAllowedMass: 85,
    maxAllowedMassAstm: 64,
  },
  {
    id: "0.25",
    sieveSizeMm: 0.25,
    label: "0.25 mm",
    labelAstm: "No.60",
    maxAllowedMass: 79,
    maxAllowedMassAstm: 60,
  },
  {
    id: "0.212",
    sieveSizeMm: 0.212,
    label: "0.212 mm",
    maxAllowedMass: 70,
  },
  {
    id: "0.18",
    sieveSizeMm: 0.18,
    label: "0.18 mm",
    maxAllowedMass: 67,
  },
  {
    id: "0.15",
    sieveSizeMm: 0.15,
    label: "0.15 mm",
    labelAstm: "No.100",
    maxAllowedMass: 60,
    maxAllowedMassAstm: 40,
  },
  {
    id: "0.125",
    sieveSizeMm: 0.125,
    label: "0.125 mm",
    maxAllowedMass: 56,
  },
  {
    id: "0.106",
    sieveSizeMm: 0.106,
    label: "0.106 mm",
    labelAstm: "No.140",
    maxAllowedMass: 51,
    maxAllowedMassAstm: 30,
  },
  {
    id: "0.09",
    sieveSizeMm: 0.09,
    label: "0.09 mm",
    maxAllowedMass: 47,
  },
  {
    id: "0.075",
    sieveSizeMm: 0.075,
    label: "0.075 mm",
    labelAstm: "No.200",
    maxAllowedMass: 43,
    maxAllowedMassAstm: 20,
  },
  {
    id: "0.063",
    sieveSizeMm: 0.063,
    label: "0.063 mm",
    labelAstm: "No.230",
    maxAllowedMass: 40,
    maxAllowedMassAstm: undefined,
  },
];
const boundarySieveIds = new Set(["2", "0.63", "0.212", "0.063"]);
export const boundarySieves = knownSieves.filter((sieve) => boundarySieveIds.has(sieve.id));

export const resolveFilteredSieves = (sieveIds: string[]) => knownSieves.filter((sieve) => sieveIds.includes(sieve.id));

export const getAstmSieves = (): SieveRecord[] =>
  knownSieves.flatMap((sieve) =>
    sieve.labelAstm !== undefined ? [{ id: sieve.id, sieveSizeMm: sieve.sieveSizeMm, label: sieve.labelAstm }] : [],
  );

export const allSieves = knownSieves;

const maxLoadById = new Map(knownSieves.map((s) => [s.id, s.maxAllowedMass]));
const maxLoadAstmById = new Map(
  knownSieves.flatMap((s): [string, number][] =>
    s.maxAllowedMassAstm !== undefined ? [[s.id, s.maxAllowedMassAstm]] : [],
  ),
);
const sortedSizes = knownSieves.map((s) => s.sieveSizeMm).sort((a, b) => b - a);

export const getSieveMaxLoad = (sizeRef: string): number | undefined => {
  const direct = maxLoadById.get(sizeRef);
  if (direct !== undefined) return direct;

  const sizeNum = parseFloat(sizeRef);
  if (Number.isNaN(sizeNum)) return undefined;

  const matchSize = sortedSizes.find((s) => s <= sizeNum);
  if (matchSize !== undefined) {
    const sieve = knownSieves.find((s) => s.sieveSizeMm === matchSize);
    return sieve?.maxAllowedMass;
  }
  return undefined;
};

export const getSieveAstmMaxLoad = (sizeRef: string): number | undefined => {
  const direct = maxLoadAstmById.get(sizeRef);
  if (direct !== undefined) return direct;

  return undefined;
};

const astmHydrometerBoundarySieveIds = ["2", "0.85", "0.425", "0.25", "0.15", "0.106", "0.075"];
export const astmHydrometerBoundarySieves: SieveRecord[] = knownSieves
  .filter((s) => astmHydrometerBoundarySieveIds.includes(s.id))
  .map((s) => ({
    id: s.id,
    sieveSizeMm: s.sieveSizeMm,
    label: s.labelAstm ?? s.label,
  }));
